import React, { useEffect } from 'react';
import Header from '@/components/header';
import Viewer from '@/components/PDF/Viewer';
import { SafeAreaView } from 'react-native-safe-area-context';

export default function PDFViewer() {
  return (
    <SafeAreaView style={{ width:'100%', flex: 1, margin:0, padding: 0 }}>
      <Header />
      <Viewer />
    </SafeAreaView>
  );
}